export default {
  props: {
    title: {
      type: String,
      default: "",
    },

    subtitle: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "10",
    },
    optionList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/settings/components/package_card.ctrl.js